import React , { useEffect, useState } from 'react';
import { Button , Modal } from 'antd';
import {
    InfoCircleOutlined
  } from '@ant-design/icons';
import { AGENT_COLORS_ACCESS_TOKEN_KEY } from '../../utils/constant';
import { getLocalStorage, isValid } from '../../utils/utilities';

export const SeatLegend = props => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [seatColors, setSeatColors] = useState([]);

    useEffect(()=>{
        let agentPortalColors = getLocalStorage(AGENT_COLORS_ACCESS_TOKEN_KEY);         
        if(isValid(agentPortalColors)){
            agentPortalColors=JSON.parse(agentPortalColors);
            setSeatColors([
                // General seats
                {type: 'ladies-seat', color: '#FFC0CB', category:"bordered", heading:"General"},
                {type: 'gents-seat', color: '#1D2A80', category:"bordered", heading:"General"},
                {type:"general", color:"#90EE90", category:"bordered", heading:"General"},
                // Booked seats
                {type:"office", color:agentPortalColors.officebookedmale, category:"filled", heading:"Booked", name:"Office", 
                    gender :'male'},
                {type:"office", color:agentPortalColors.officebookedfemale, category:"filled", heading:"Booked", name:"Office", 
                    gender :'female'},
                {type:"self", color:agentPortalColors.selfbookedmale, category:"filled", heading:"Booked", name:"Self",
                    gender :'male'},
                {type:"self", color:agentPortalColors.selfbookedfemale, category:"filled", heading:"Booked", name:"Self",
                    gender :'female'},
                {type:"agent", color:agentPortalColors.agentbookedmale, category:"filled", heading:"Booked", name:"Agent",
                    gender :'male'},
                {type:"agent", color:agentPortalColors.agentbookedfemale, category:"filled", heading:"Booked", name:"Agent",
                    gender :'female'},
                {type:"ota", color:agentPortalColors.otabookedmale, category:"filled", heading:"Booked", name:"OTA",
                    gender :'male'},
                {type:"ota", color:agentPortalColors.otabookedfemale, category:"filled", heading:"Booked", name:"OTA",
                    gender :'female'},
                {type:"website", color:agentPortalColors.websitebookedmale, category:"filled", heading:"Booked", name:"Website",
                    gender :'male'},
                {type:"website", color:agentPortalColors.websitebookedfemale, category:"filled", heading:"Booked", name:"Website",
                    gender :'female'},
        
                // Blocked seats
                {type:"office", color:agentPortalColors.officeblockedmale, category:"filled", heading:"Blocked", name:"Office",
                    gender :'male'},
                {type:"office", color:agentPortalColors.officeblockedfemale, category:"filled", heading:"Blocked", name:"Office",
                    gender :'female'},
                {type:"self", color:agentPortalColors.selfblockedmale, category:"filled", heading:"Blocked", name:"Self",
                    gender :'male'},
                {type:"self", color:agentPortalColors.selfblockedfemale, category:"filled", heading:"Blocked", name:"Self",
                    gender :'female'},
                {type:"agent", color:agentPortalColors.agentblockedmale, category:"filled", heading:"Blocked", name:"Agent",
                    gender :'male'},
                {type:"agent", color:agentPortalColors.agentblockedfemale, category:"filled", heading:"Blocked", name:"Agent",
                    gender :'female'},
                {type:"ota", color:agentPortalColors.otablockedmale, category:"filled", heading:"Blocked", name:"OTA",
                    gender :'male'},
                {type:"ota", color:agentPortalColors.otablockedfemale, category:"filled", heading:"Blocked", name:"OTA",
                    gender :'female'},
        
                // Admin and Phone blocked
                {type:"adminblockedself", color:agentPortalColors.adminblockedself, category:"filled", heading:"Blocked", name:"Admin self"},
                {type:"adminblockedothers", color:agentPortalColors.adminblockedothers, category:"filled", heading:"Blocked", name:"Admin others"},
                {type:"phoneblocked", color:agentPortalColors.phoneblockedgeneral, category:"filled", heading:"Blocked", name:"Phone"},

                // Selected seat 
                {type:"seat", color:agentPortalColors.selectedseat, category:"filled", heading:"General", name:"Selected"},
                {typr:"vacant", color:agentPortalColors.vacantseat , category:"filled", heading:"General", name:"Vacant"}
            ]);
        }
    },[]);

    const showModal = () => {
      setIsModalVisible(true);
    };
  
    const handleOk = () => {
      setIsModalVisible(false);
    };
  
    const handleCancel = () => {
      setIsModalVisible(false);
    };
    return (
        <div className='seat-legend-root'>
            <Button onClick={showModal} className="outline-button">
                <div className="indicator-container">
                    <div className="indicator-description">
                        <span className='seat-colors-txt'>Seat Colors</span>
                        <InfoCircleOutlined />
                    </div>
                </div>
            </Button>
            <Modal 
                title="Legends" 
                maskClosable={false}
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={500}
            >
                <div className="seat-indicator-container">
                    <div className="legend-headers">
                        {['General', 'Booked', 'Blocked'].map(header => (
                            <div key={header} className="legend-header">{header}</div>
                        ))}
                    </div>
                    <div className="seat-indicator-content">
                        {Object.entries(
                            seatColors.reduce((acc, seat) => {
                                // Group by heading first
                                if (!acc[seat.heading]) {
                                    acc[seat.heading] = {};
                                }
                                
                                // Create key based on color and category, but group by type for gender variants
                                let key;
                                if (seat.gender && seat.name) {
                                    // For gender variants, group by color-category-type
                                    key = `${seat.color}-${seat.category}-${seat.name}`;
                                } else if (seat.name) {
                                    // For non-gender variants with name, use color-category-name
                                    key = `${seat.color}-${seat.category}-${seat.name}`;
                                } else {
                                    // For non-gender variants without name, use color-category
                                    key = `${seat.color}-${seat.category}`;
                                }
                                
                                if (!acc[seat.heading][key]) {
                                    acc[seat.heading][key] = {
                                        names: [],
                                        color: seat.color,
                                        category: seat.category,
                                        type: seat.name || seat.type
                                    };
                                }

                                // Add name with type handling
                                if (seat.type === 'ladies-seat' || seat.type === 'gents-seat') {
                                    acc[seat.heading][key].names.push(seat.type);
                                } else if (seat.gender && seat.name) {
                                    // For seats with male/female variants, add both variants
                                    const genderSuffix = seat.gender === 'male' ? ' (M)' : ' (F)';
                                    const displayName = seat.name + genderSuffix;
                                    if (!acc[seat.heading][key].names.includes(displayName)) {
                                        acc[seat.heading][key].names.push(displayName);
                                    }
                                } else if (seat.name) {
                                    // For admin and phone blocked
                                    if (!acc[seat.heading][key].names.includes(seat.name)) {
                                        acc[seat.heading][key].names.push(seat.name);
                                    }
                                } else {
                                    // For other cases
                                    acc[seat.heading][key].names.push(seat.type);
                                }
                                
                                return acc;
                            }, {})
                        ).map(([heading, groups]) => (
                            <div key={heading} className="legend-column">
                                {Object.entries(groups).map(([key, group]) => (
                                    <div key={key} className="legend-item">
                                        <div className="legend-text">
                                            {group.names.map(name => (
                                                <span key={name} className="legend-name">
                                                    {name.replace(/([A-Z])/g, ' $1')
                                                         .replace(/-seat/g, '')
                                                         .replace(/blocked/g, '')
                                                         .trim()}
                                                </span>
                                            ))}
                                        </div>
                                        <div
                                            className="color-box"
                                            style={{
                                                ...(group.category === 'bordered' 
                                                    ? {
                                                        border: `2px solid ${group.color}`,
                                                        backgroundColor: 'white'
                                                      }
                                                    : {
                                                        backgroundColor: group.color
                                                      }
                                                )
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

SeatLegend.defaultProps = {

};

SeatLegend.propTypes = {

};
